import React, { useEffect } from "react";
import LockedPage from "../Locked";
import { useNavigationBar } from "../../context/NavigationContext";
import ContainerNavigation from "../../components/ContainerNavigation";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import ListMembers from "./ListMembers";

const Members = () => {
  const { setNavProps, navProps } = useNavigationBar();

  const navigate = useNavigate();
  useEffect(() => {
    setNavProps({
      backArrow: false,
      title: "Ananlytics",
      subtitle: "Channel",
      buttonTitle: "Onboarding",
      filterOption: false,
      enableLink: true,
      onBack: () => alert("Back Clicked"),
      onFilter: () => {},
      onNext: () => navigate("../onboarding"),
    });
  }, [setNavProps, navigate]);

  const { backArrow, title, subtitle, buttonTitle, enableLink, filterOption, onBack, onFilter, onNext } = navProps;

  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate replace to="./list" />} />
        <Route path="/list" element={<ListMembers />} />
      </Routes>
      {/* <ContainerNavigation
        backArrow={backArrow}
        title={title}
        subtitle={subtitle}
        enableLink={enableLink}
        buttonTitle={buttonTitle}
        filterOption={filterOption}
        onBack={onBack}
        onFilter={onFilter}
        onNext={onNext}
      />
      <LockedPage content="manage Team Members" /> */}
    </>
  );
  //
};

export default Members;
